import React from "react";
import CommunityDetail from "../../../components/CommunityDetail";

const CommunityNanumDetail = () => {
  return <CommunityDetail posttype="nanum" />;
};

export default CommunityNanumDetail;
